import React from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { logout } from '../actions/userActions'


const Header = () => {

  const dispatch = useDispatch()

  const history = useHistory()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin
  
  const logoutHandler = () => {
    dispatch(logout())
    history.push('/')
  }

  return (
    <header>
      <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect>
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>Katastar</Navbar.Brand>
          </LinkContainer>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {userInfo && userInfo.superAdmin && <LinkContainer to="/register">
                <Nav.Link>
                  <i className="fas fa-user-plus"></i> Novi korisnik
                </Nav.Link>
              </LinkContainer>}
              {userInfo && userInfo.superAdmin && 
                <NavDropdown title='Ažuriranje'>
                  <LinkContainer to='/azuriranje'>
                    <NavDropdown.Item>Ažuriranje stuba</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              }
              {userInfo && userInfo.isAdmin && (
                <NavDropdown title='Izvestaji' id='adminmenu'>
                <LinkContainer to='/admin/izvestaji'>
                  <NavDropdown.Item>Kvarovi za mesto</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to='/admin/istorija'>
                  <NavDropdown.Item>Istorija za stub</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>
              )}
              {userInfo ? (
                <NavDropdown title={userInfo.name} id='username'>
                  <LinkContainer to='/profile'>
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : <LinkContainer to="/login">
                <Nav.Link>
                  <i className="fas fa-user"></i> Sign In
                </Nav.Link>
              </LinkContainer>}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;

